import React from 'react';

import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const ButtonLoaderAtom = (props) => {
  const { active } = props;
  if (!active) return null;
  return (
    <span className={styles['ball-clip-rotate']}>
      <div />
    </span>
  );
};

ButtonLoaderAtom.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default ButtonLoaderAtom;
